$(".location-slider").slick({
  dots: !0,
  infinite: !0,
  slidesToShow: 3,
  arrows: !0,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 2 } },
    { breakpoint: 768, settings: { slidesToShow: 2 } },
    { breakpoint: 480, settings: { slidesToShow: 1 } },
  ],
}),
  $(".slider-two").slick({
    dots: !1,
    infinite: !0,
    slidesToShow: 1,
    centerMode: !0,
    centerPadding: "370px",
    arrows: !1,
    autoplaySpeed: 0,
    speed: 11e3,
    autoplay: !0,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: !1,
          centerMode: !0,
          centerPadding: "100px",
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: !1,
          centerMode: !0,
          centerPadding: "40px",
          slidesToShow: 1,
        },
      },
    ],
  }),
  $(".slider-two2").slick({
    dots: !1,
    infinite: !0,
    slidesToShow: 1,
    centerMode: !0,
    centerPadding: "370px",
    arrows: !1,
    autoplaySpeed: 0,
    speed: 11e3,
    autoplay: !0,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: !1,
          centerMode: !0,
          centerPadding: "100px",
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: !1,
          centerMode: !0,
          centerPadding: "40px",
          slidesToShow: 1,
        },
      },
    ],
  }),
  $(".slider-one").slick({
    dots: !1,
    infinite: !0,
    slidesToShow: 1,
    centerMode: !0,
    centerPadding: "370px",
    arrows: !1,
    autoplay: !0,
    slidesToScroll: -1,
    speed: 12e3,
    autoplaySpeed: 0,
    cssEase: "linear",
    rtl: !1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: !1,
          centerMode: !0,
          centerPadding: "100px",
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: !1,
          centerMode: !0,
          centerPadding: "40px",
          slidesToShow: 1,
        },
      },
    ],
  }),
  $(".slider-one2").slick({
    dots: !1,
    infinite: !0,
    slidesToShow: 1,
    centerMode: !0,
    centerPadding: "370px",
    arrows: !1,
    autoplay: !0,
    slidesToScroll: -1,
    speed: 12e3,
    autoplaySpeed: 0,
    cssEase: "linear",
    rtl: !1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: !1,
          centerMode: !0,
          centerPadding: "100px",
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: !1,
          centerMode: !0,
          centerPadding: "40px",
          slidesToShow: 1,
        },
      },
    ],
  });
